import React, { useState } from 'react';

import ConfirmationOverlay from 'shared/ConfirmationOverlay';

export interface ConfirmCloseMillingOrderComponentProps {
  // PLA-860: en la OTT del flujo nuevo no se puede cerrar sin el analisis de pasillas.
  disabled?: boolean;
}

const ConfirmCloseMillingOrderComponent: React.FC<
  ConfirmCloseMillingOrderComponentProps
> = ({ disabled = false }) => {
  const [showOverlay, setOverlay] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleOnPrimaryClick = () => {
    const form = document.querySelector(
      'form[data-cy="close_milling_order_form"]'
    ) as HTMLFormElement | null;

    if (!form) {
      return;
    }

    // If there are invalid fields (e.g. required Area/Bin/Level/Position left
    // empty), we don't submit or disable the button: we close the overlay so the
    // fields stay visible and surface the reason via native validation, which
    // scrolls to and focuses the first invalid field. Previously submitted=true was
    // set and requestSubmit() stayed blocked, leaving the button disabled without
    // showing the cause (the bubble ended up behind the modal).
    if (!form.checkValidity()) {
      setOverlay(false);
      setTimeout(() => form.reportValidity(), 0);
      return;
    }

    setSubmitted(true);
    form.requestSubmit();
  };

  return (
    <>
      {showOverlay && (
        <ConfirmationOverlay
          title={I18n.translate('milling_orders.finalise_milling.close_milling')}
          confirmText={I18n.translate('buttons.confirm')}
          onConfirmClick={handleOnPrimaryClick}
          cancelText={I18n.translate('buttons.cancel')}
          primaryDisabled={submitted}
          onCancelClick={() => setOverlay(false)}
        />
      )}

      <button
        type='button'
        className='button'
        data-cy='close_milling_order_button'
        disabled={disabled}
        onClick={() => setOverlay(true)}
      >
        {I18n.translate('buttons.close')}
      </button>
    </>
  );
};

export default ConfirmCloseMillingOrderComponent;
